import { AddedToCartLayerProduct } from '@spa/components/add-to-cart/added-to-cart-layer.component';
import type { ProductInfoProduct } from '@spa/components/product-info/ProductInfoProductTypes';
import { WishlistItemProduct } from '@spa/components/wishlist-details/WishlistDetailsTypes';

const convertProductToAddedToCartLayerProduct = ({
  currentPrice,
  campaignPrice,
  basePrice,
  strikePrice,
  images,
  name,
  recommendedRetailPrice
}: ProductInfoProduct | WishlistItemProduct): AddedToCartLayerProduct => ({
  currentPrice,
  campaignPrice,
  basePrice,
  strikePrice,
  image: images?.[0] ?? null,
  name,
  recommendedRetailPrice
});

export default convertProductToAddedToCartLayerProduct;
